import React from 'react'

import Popover, { Props as PopoverProps } from '../Popover'
import styles from './styles.module.scss'
import VisitorUserForm, { FormValues } from '../../../forms/VisitorUserForm'

interface Props extends PopoverProps {
  onFormSubmit: (values: FormValues) => Promise<void>
}

const LikePopover: React.FC<Props> = ({ onFormSubmit, ...props }) => {
  return (
    <Popover {...props}>
      <div style={{ width: 240 }}>
        <p className={styles.smallBold}>Let the family know who you are.</p>

        <p className={styles.small}>(You only have to do this once.)</p>

        <VisitorUserForm
          initialValues={{ email: '', name: '', location: '' }}
          onSubmit={onFormSubmit}
        />
      </div>
    </Popover>
  )
}

export default LikePopover
